/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_CANDIDAT_SEANCE(state, candidat_seances) {
    state.candidat_seances = candidat_seances
  },
  SET_Participation_candidat_seances(state, participation_candidat_seance) {
    state.participation_candidat_seance = participation_candidat_seance
  },
  ADD_Participation_candidat_seances(state, item) {
    state.participation_candidat_seance.unshift(item)
  },
  UPDATE_Participation_candidat_seances(state, user) {
    const eventIndex = state.participation_candidat_seance.findIndex((e) => e.id == user.id)
    Object.assign(state.participation_candidat_seance[eventIndex], user)
},
  ADD_ITEM(state, item) {
    state.users.unshift(item)
  },
  SET_USERS(state, users) {
    state.users = users
  },
  SET_SEANCE(state, seance) {
    state.seance = seance
  },
  REMOVE_RECORD(state, itemId) {
      const userIndex = state.users.findIndex((u) => u.id == itemId)
      state.users.splice(userIndex, 1)
  },
  UPDATE_USERS(state, user) {
    const eventIndex = state.users.findIndex((e) => e.id == user.id)
    Object.assign(state.users[eventIndex], user)
},
}
